/**
 * API URL 정보
 */

export const API_TEST_URL = '/api/test'

export const API_CODE_TEST_URL = '/api/code/test'

export const COMMON_CODE = '/api/cm/selectComCodeList' // djyoo 21.07.15  공통 코드 조회

// djyoo 21.07.15 item-qry-service.ts
export const ITEM_LIST = '/api/pd/item/selectSellItemList' // 상품 리스트 검색
export const UPDATE_SELL_GBCD_ILMP = '/api/pd/item/updateSellItemBasicProcessList' // 상품 판매상태 일괄 변경
export const UPDATE_SELL_GBCD = '/api/pd/item/updateSellItemBasicProcess' // 상품 판매상태 변경
export const UPDATE_ITNT_DISP = '/api/pd/item/updateSellItemBasicProcess' // 상품 전시/미전시 변경
export const ITEM_PROGRESS_COUNT = '/api/pd/item/selectSlitmAprvlGbcdList' // 진행단계별 건수 조회
export const ITEM_DTL = '/api/pd/item/selectItem' // 상품 상세 조회
export const SDLVC_VEN_DTL = '/api/pd/item/selectSdlvcVenDtl' // 협력사별 소액배송비 조회
export const CRCRD_INSM_CMISR_INF = '/api/pd/item/selectCrcrdInsmCmisrInf' // 신용카드 수수료율 조회
export const DPTS_VEN_OP_CD = '/api/pd/item/selectDptsVenOpCd' // 백화점 상품 마진정보 가져오기
export const DPTS_OP_CD = '/api/pd/item/selectDptsOpCd' // 백화점OP코드 조회
export const BSIC_CODE_LIST = '/api/pd/item/selectBsicCodeList' // 상품등록 관련 기본 데이터를 조회
export const ITEM_GBCD_AND_INTG_GBCD = '/api/pd/item/selectItemGbcdAndIntgGbcd' // 상품의 유형/무형 조회
export const MULTI_ITEM = '/api/pd/item/multiItem' // 상품 상세 수정
export const MULTI_ITEM_IMG = '/api/pd/item/multiItemImg' // 상품 상세 이미지 업로드
export const DPTS_VEN_ITEM_WITH_ITEM_CD = '/api/pd/item/selectDptsVenItemWithItemCdList' // 백화점 상품코드 조회
export const CHEM_ISPT_CD_LIST = '/api/pd/item/selectChemIsptCdList' // 생활화학 키워드 체크
export const CHILD_ITEM_KWRD = '/api/pd/item/selectChildItemKwrd' // 어린이 키워드 체크
export const BLCWD_MST_BY_ITEM_CSF_CD = '/api/pd/item/selectBlcwdMstByItemCsfCd' // 블랙 키워드 리스트 조회
export const ISPT_KWRD02_BY_ITEM_CSF_CD = '/api/pd/item/selectIsptKwrd02ByItemCsfCd' // 금지어 리스트 조회
export const IM_SLITM_PRC_ATHZ_HIS_LIST = '/api/pd/item/selectImSlitmPrcAthzHisList' // 판매가 적용 예정 일정 보기

// djyoo 21.07.15 stck-crst-service.ts
export const STOCK_LIST = '/api/sc/stockCrst/selectStockStatusList' // 재고 리스트 검색
export const STOCK_DTL = '/api/sc/stockCrst/selectStockStatusDetailList' // 재고 상품별 상세

// 방송관련
export const BROD_EQMT_MNG_LIST = '/api/beqmt/brodmng/brodEqmtList' // 방송장비리스트
export const BROD_EQMT_ATFL_DEL = '/api/beqmt/brodmng/deleteBrodEqmtAtflList' // 방송장비상세 이미지 파일삭제
export const BROD_EQMT_ATFL_IMG_UPLOAD = '/api/beqmt/brodmng/multiBrodEqmtAtfl' // 방송장비상세 이미지 업로드

export const BROD_CODE_GDBC_LIST = '/api/beqmt/common/brodCodeGdbcList' // 방송조건공통코드
export const BROD_EQMT_MATH_DTL_MNG = '/api/beqmt/mathdtl/beqmtMatnDtlMng' // 장비 유지보수 내역 화면 호출
export const BROD_EQMT_MATH_PTC_DTL = '/api/beqmt/mathdtl/selectEqmtMatnPtcDtl' // 장비 유지보수 내역 화면 호출
export const BROD_EQMT_MATH_IMG_DEL = '/api/beqmt/mathdtl/deleteEqmtMatnAtflDtl' //  이미지 삭제

export const BROD_EQMT_PTC_QRY = '/api/beqmt/mathdtl/selectBrodEqmtPtcQry' // 방송장비상세 조회
export const BROD_EQMT_MATH_DTL_MNG_LIST = '/api/beqmt/mathdtl/selectEqmtMatnDtlList' // 방송유지보수내역 조회
export const BROD_EQMT_MATH_REG_CHK = '/api/beqmt/mathdtl/selectMatnRegChk' // 방송유지보수내역 조회
export const BROD_EQMT_MATH_SAVE = '/api/beqmt/mathdtl/multiEqmtMatnAtflDtl' // 방송장비 내용 등록/수정 및 이미지 업로드

export const BROD_EXPE_MNG_LIST = '/api/beqmt/exptmng/beqmtExpeMngList' // 소모품리스트
export const BROD_VEN_MNG_LIST = '/api/beqmt/venmng/beqmtVenMngList' // 거래처현황
export const BROD_VEN_EMP_TEL_LIST = '/api/beqmt/venmng/selectEqmtVenEmpCtelList' // 담당자 리스트
export const BROD_VEN_LIST = '/api/beqmt/venmng/selectEqmtVenList' // 거래처 리스트

export const BFMT_SCHE_LIST = '/api/bm/bfmt/selectBfmtScheList' // 방송 편성 스케줄 조회
export const BFMT_ASG_LIST = '/api/bm/bfmt/selectPgmAsgList' // 프로그램 배정 상세 조회

// 상품설명회
export const EXT_ES_INDEX = '/api/smart/ext/esIndex' // 상품설명회 목록 가져오기
export const EXT_ES_MAIN = '/api/smart/ext/esMain' // 해당 품평회에 대한 정보를 가져온다.
export const EXT_ES_DETAIL = '/api/smart/ext/esDetail' // 화면에 나타날 상품정보 및 평가데이터를 가져온다.
export const EXT_ES_MERGE = '/api/smart/ext/estimationMergeData' //  품평회 작성
